module.exports = __webpack_public_path__ + "static/img/y1.203901a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3x/y1.png
// module id = lEZ6
// module chunks = 1